import { createRouter, createWebHistory } from 'vue-router';
import HomeGuestView from '@/views/HomeGuestView.vue';
import LoginForm from '@/views/auth/loginForm.vue';

import NotFoundView404 from '@/views/fsrPage404.vue';

const routes = [
  {
    path: '/',
    component: HomeGuestView
  },
  {
    path: '/login',
    name: 'login',
    component: LoginForm
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFoundView404',
    component: NotFoundView404
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
